module.exports = __webpack_public_path__ + "static/assets/40b307fe8a0e2f3c6fbee5caacb3dbca.svg";